// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "1.3.5-rc1-2-ga6b3d722-dirty",
    "hash": "ga6b3d722",
    "distance": 2,
    "tag": "1.3.5-rc1",
    "semver": {
        "options": {
            "loose": false,
            "includePrerelease": false
        },
        "loose": false,
        "raw": "1.3.5-rc1",
        "major": 1,
        "minor": 3,
        "patch": 5,
        "prerelease": [
            "rc1"
        ],
        "build": [],
        "version": "1.3.5-rc1"
    },
    "suffix": "2-ga6b3d722-dirty",
    "semverString": "1.3.5-rc1+2.ga6b3d722",
    "date": "2025-04-08T06:37:23.211Z"
};
/* tslint:enable */
